export default "__VITE_PUBLIC_ASSET__0bcdf867__"